import { trim } from './utils';

// 验证用户名
export const checkUserName = value => {
  return /^[A-Za-z0-9_\-@\\.]{6,32}$/g.test(value);
};

// 验证协议Key
export const checkDataSrcKey = value => {
  const newValue = value;
  // 如果有空格，不允许
  // eslint-disable-next-line no-useless-escape
  if (/ /gi.test(newValue) || /[\(\)\*\?]/gi.test(newValue)) {
    return false;
  }
  return true;

  // return /^[A-Za-z0-9_]{4,64}$/g.test(value);
};

// 验证密码复杂度
export const checkPassword = value => {
  var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,32}');
  return pwdRegex.test(value);
};

// 检查为空
export const validateEmptyStr = (rule, value, callback) => {
  if (value && value.length > 0) {
    // 不能全部为空格
    if (!trim(value) && value.length > 0) {
      callback(new Error(window.$t('com_form_error_spaces_trim')));
      return;
    }

    // 前后不能以换行/换页/制表/回车/垂直制表符开头或结尾
    if (!/^[^\s].*[^\s]$/gi.test(value)) {
      callback(new Error(window.$t('com_form_error_spaces')));
      return;
    }
  }

  callback();
};
